import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

type Params = {
	meetingId: string;
	meetingWasOK: boolean;
	problemMessage?: string;
};

export const signMeetingOff = makeSubmitData<Params>("signMeetingOff");
